import { Reveal } from "@/components/site/Reveal";
import { MEDIA } from "@/lib/collection";

export default function Concept() {
  return (
    <section
      id="concept"
      data-testid="concept-section"
      className="bg-[#faf8f5] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-[#a89f8e]">
            01 — The concept
          </span>
        </Reveal>

        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-4xl font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#111111]">
            An empty wall isn't a lack.
            <span className="italic text-[#a89f8e]"> It's a promise.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="space-y-7 text-base md:text-lg font-light leading-relaxed text-[#111111]/80">
              <p>
                Today, art hides behind unreachable glass, in hushed rooms where
                masterpieces have become little more than names hung on the walls
                of museums and great collections. For most of us, owning a work
                has become a distant dream — almost unreal.
              </p>
              <p>
                That is where “The X Goes Here” was born: a cross painted on the
                wall, and a handwritten line that names the absence with as much
                seriousness as irony — “The Picasso goes here!”. The X doesn't
                mark a void. It marks a dream.
              </p>
              <p>
                With humour and poetry, the concept turns an ordinary wall into a
                manifesto: the right to dream big, at home.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2} className="lg:col-span-5">
            <figure className="border-l border-[#111111] pl-8 py-2">
              <blockquote
                data-testid="concept-quote"
                className="font-display italic text-2xl md:text-3xl leading-snug text-[#111111]"
              >
                “And if it isn't a Picasso, it's already an idea that makes people
                talk, smile and dream.”
              </blockquote>
            </figure>

            <div className="mt-10 overflow-hidden">
              <img
                src={MEDIA.conceptWall}
                alt="A salon-hang gallery wall of framed « X goes here » posters — a whole collection of dreamed masterpieces"
                className="w-full h-[300px] md:h-[360px] object-cover transition-transform duration-[1.2s] ease-out hover:scale-[1.04]"
                data-testid="concept-image"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
